import PropTypes from 'prop-types';
import React from 'react';
import Head from 'next/head';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { formatHttpsUrl } from '@utils/utils';
import StudioWrapper from '../StudioWrapper';
import AuthorPageStyles from './Author.styled';
import PostsDeck from '@components/Studio/PostsDeck/PostsDeck';
import BodyContent from '@components/Studio/BodyContent/BodyContent';
import { getSiteUrl } from '@utils/config';

const Author = ({ author, summary, curatedButtons = [] }) => {
  let avatarImageUrl =
    formatHttpsUrl(`${author.authorImage.file.url}?w=500&q=100`) || null;
  let biography = author.authorBiography ? author.authorBiography : null;

  const router = useRouter();

  return (
    <StudioWrapper posts={summary.allPosts} curatedButtons={curatedButtons}>
      <AuthorPageStyles>
        <Head>
          <title>{author.titleTag} | Clayton Homes</title>
          <meta name="description" content={author.metaDescription} />
          <link
            rel="canonical"
            href={`${getSiteUrl(
              router.asPath.endsWith('/') ? router.asPath : router.asPath + '/'
            )}`}
          />
        </Head>

        <div className="author-info">
          {avatarImageUrl ? (
            <div className="author-image">
              <Image
                className="image"
                src={avatarImageUrl}
                alt={author.authorName}
                title={author.authorName}
                width={500}
                height={500}
              />
            </div>
          ) : null}

          <div className="author-biography">
            <div className="meet-the-author">Meet the Author</div>

            <div className="h2">{author.authorName}</div>

            <div className="biography-text">
              <BodyContent markdown={biography} />
            </div>
          </div>
        </div>

        <div className="author-posts">
          <PostsDeck
            headline={'Posts by ' + author.authorName}
            posts={author.authorsPosts}
            loadMore={true}
          />
        </div>
      </AuthorPageStyles>
    </StudioWrapper>
  );
};

Author.propTypes = {
  author: PropTypes.shape({
    authorBiography: PropTypes.any,
    authorImage: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.any,
      }),
    }),
    authorName: PropTypes.any,
    authorsPosts: PropTypes.any,
    metaDescription: PropTypes.any,
    titleTag: PropTypes.any,
  }),
  curatedButtons: PropTypes.array,
  summary: PropTypes.shape({
    allPosts: PropTypes.any,
  }),
};

export default Author;
